import { FC } from 'react';
import { ClaimsComponent } from '@/_shared/components/Claims';
import { DialogLogout } from '@/_shared/components/DialogLogout';
import { PlatformType } from '@/_shared/constants';
import { DialogContacts, DialogContactsFeedback } from '@/core/components/DialogContacts';
import { DialogCreditsUser } from '@/credits/components';
import { DialogStartDocument } from '@/training/documents/components/DialogStartDocument';
import { DialogStartQuiz } from '@/training/quiz/components/DialogStartQuiz/DialogStartQuiz';
import { DialogStartVideo } from '@/training/video/components/DialogStartVideo';

export const GenericDialog: FC = () => {
  return (
    <>
      <ClaimsComponent platform={PlatformType.LEARNING}>
        <DialogCreditsUser />
      </ClaimsComponent>
      <DialogStartQuiz />
      <DialogStartVideo />
      <DialogStartDocument />
      <DialogLogout />
      <ClaimsComponent platform={PlatformType.ADMIN}>
        <DialogContacts />
      </ClaimsComponent>
      <ClaimsComponent platform={PlatformType.ADMIN}>
        <DialogContactsFeedback />
      </ClaimsComponent>
    </>
  );
};
